import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { IValidationHandler, TValidatorError } from '../../model';
import { ValidationPatterns } from '../validation-patterns';

export function hebrewConsecutiveCharsValidator(args: IValidationHandler): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const { value, invalid } = control;

    if (invalid) return null;

    if (!value) return null;

    const vldResponse: TValidatorError = { hebrewConsecutiveChars: value };

    /** check control's value against whitelist chars */
    const matchHebName = value.match(ValidationPatterns.hebrewPhrase);

    if (!matchHebName?.length) {
      return vldResponse;
    }

    /** disallow 3 or more consecutive identical hebrew chars */
    const matchConsecutive3 = value.match(ValidationPatterns.hebConsecutive3);

    if (matchConsecutive3?.length) {
      return vldResponse;
    }

    /** disallow 2 consecutive identical hebrew chars when value is only 2 chars long */
    if (value?.length === 2) {
      const matchConsecutive2 = value.match(ValidationPatterns.hebConsecutive2);

      if (matchConsecutive2?.length) {
        return vldResponse;
      }
    }

    /** disallow final letters in the middle or at the start of the word */
    const matchHebSuffixLetters = value.match(ValidationPatterns.hebSuffixLetters);

    if (matchHebSuffixLetters?.length) {
      return vldResponse;
    }

    return null;
  };
}
